import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/timeline')({
  component: () => <PageStub title="Timeline" description="Activity feed and history" />,
});
